export const environment = {
  production: true,
  appVersion: "v" + require('../../package.json').version,
  firebase: {
    apiKey: "AIzaSyDHDYPWNjO-XY-i59idqu3zHV8mEm2GHXs",
    authDomain: "my.quovado.com",
    databaseURL: "https://wanderoo-website.firebaseio.com",
    projectId: "wanderoo-website",
    storageBucket: "wanderoo-website.appspot.com",
    messagingSenderId: "472543531812",
    appId: "1:472543531812:web:164bb02987022309dfd9b1",
    region: "us-central1"
  },
  googleAnalyticsMeasurementId: "G-9MHZNN97K3",
  googleMapsApiKey: "AIzaSyCp_VQASHr57ZTGoMDu6IlqJfsLkrhTTho",
  stackdriverErrorReportingApiKey: "AIzaSyBAeqUALzyQ2fcJktVRWV8swlRpagvqctM",
  rendererPreviewUrl: {
    "it": "https://wanderoo-renderer.web.app",
    "en": "https://wanderoo-renderer-en.web.app"
  },
  corsProxyUrl: "https://cors-anywhere-35dai3t2cq-lz.a.run.app",
  maxNdays: 35
};
